import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const PageLoadSpinner = () => {
  return <CircularProgress size={60} thickness={7} style={{ position: 'fixed', top: '25%', left: '50%' }} />;
};

export default PageLoadSpinner;
